import base from '@/__vue2stone/service/wasaapi/v1/__base';
import store from '@/store';
import axios from 'axios'

export default {
  async index(params) {
    const currentFactoryId = store.state.app.factory.id;
    const res = await base.index({
      parentName: 'v1/factory',
      parentId: currentFactoryId,
      modelName: 'factory_effect',
      params,
    });
    return res;
  },
  async delete(id) {
    const currentFactoryId = store.state.app.factory.id;
    const params = {
      factory: currentFactoryId
    };
    const res = await base.delete({
      modelName: 'v1/factory_effect',
      modelId: id,
      params,
    });
    return res;
  },
  async update(id, data) {
    const currentFactoryId = store.state.app.factory.id;
    try {
      const res = await axios.patch(
        `v1/factory_effect/${id}?factory=${currentFactoryId}`,
        data,
      );
      return res;
    } catch (error) {
      alert(error);
    }
  },
  createUrl() {
    const currentFactoryId = store.state.app.factory.id;
    return `v1/factory/${currentFactoryId}/factory_effect`;
  },
}